import { Component, Input, OnInit } from '@angular/core';
import { Insured } from '../../models/models';

@Component({
  selector: 'app-status-badge',
  templateUrl: './status-badge.component.html',
  styleUrls: ['./status-badge.component.scss'],
})
export class StatusBadgeComponent  implements OnInit {

  @Input() member: Insured;
  label: string;
  icon: string;
  tagClass: {[key: string]: boolean};

  constructor() { }

  ngOnInit() {
    const status = this.member?.statusAsObject();
    if (status) {
      this.label = status.label;
      this.icon = status.icon;
      this.tagClass = {
        'success': status.slug === 'active',
        'error': status.slug === 'removed',
        'warning': status.slug === 'future',
        'info': status.slug === 'future-active-removed',
        'secondary': status.slug === 'no-effect',
        'primary': status.slug === 'portability'
      };
    }
  }

}
